import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AdminTeamsService {
  static TIME_FRAMES = ['ALL', 'LAST_MONTH', 'LAST_YEAR']

  constructor() {
    this.endpoints = createPrefix('/admin/teams', {
      search: '/search',
    })
  }

  static create() {
    return new AdminTeamsService()
  }

  async queryTeams(params) {
    const servicePath = this.endpoints.search()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async getTeamById(id) {
    const servicePath = this.endpoints()
    const { data } = await axios.get(`${servicePath}/${id}`)
    return data
  }

  async createTeam(teamDTO) {
    const servicePath = this.endpoints()
    const { data } = await axios.post(servicePath, teamDTO)
    return data
  }

  async updateTeam(teamDTO) {
    const { id, ...payload } = teamDTO
    const servicePath = this.endpoints()
    const { data } = await axios.put(`${servicePath}/${id}`, payload)
    return data
  }

  async removeTeamById(id) {
    const servicePath = this.endpoints()
    const { data } = await axios.delete(`${servicePath}/${id}`)
    return data
  }

  async getJurisdictionList() {
    const params = { page: 0, size: 1000 }
    const { data } = await axios.get('/member/jurisdictions', { params })
    return data
  }
}
